import { Color } from "./base-data";

const colors: Color[][] = [
  ["O", "O", "Y", "O", "R", "R", "R", "G", "O", "R", "G", "G", "G", "G", "G"],
  ["B", "O", "O", "O", "G", "R", "G", "G", "Y", "R", "R", "G", "B", "Y", "Y"],
  ["Y", "B", "B", "G", "G", "R", "G", "Y", "Y", "Y", "R", "R", "B", "Y", "O"],
  ["Y", "Y", "B", "Y", "Y", "Y", "Y", "B", "B", "Y", "Y", "R", "O", "O", "O"],
  ["R", "Y", "G", "B", "B", "G", "Y", "O", "B", "B", "B", "B", "O", "B", "B"],
  ["G", "G", "G", "R", "B", "B", "B", "O", "G", "G", "O", "Y", "Y", "B", "B"],
  ["G", "R", "R", "R", "O", "O", "O", "R", "R", "O", "O", "O", "R", "R", "R"],
];

const stars: boolean[][] = [
  [
    true,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
  ],
  [
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
  ],
];

export const board = {
  colors,
  stars,
};
